import { render, staticRenderFns } from "./QuestionResponseRadioCheckbox.vue?vue&type=template&id=65c50428&scoped=true&"
import script from "./QuestionResponseRadioCheckbox.vue?vue&type=script&lang=js&"
export * from "./QuestionResponseRadioCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c50428",
  null
  
)

export default component.exports